module.exports = __webpack_public_path__ + "static/media/red_logout_icon.20f57a97.svg";